var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-page" },
    [
      _c("div", { staticClass: "filter-page-header" }, [
        _c("div", { staticClass: "filter-header-content" }, [
          _c("div", { staticClass: "filter-title-section" }, [
            _c(
              "button",
              {
                staticClass: "back-button",
                attrs: { title: _vm.$t("chat.filterPanel.backToChat") },
                on: { click: _vm.goBackToChat },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("arrow_back"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "filter-icon-container" }, [
              _c(
                "div",
                { staticClass: "filter-icon editable" },
                [
                  _c("MaterialIconPicker", {
                    attrs: { value: _vm.selectedIcon || "filter_list" },
                    on: { input: _vm.onIconSelected },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-title-text" },
              [
                !_vm.editingName
                  ? [
                      _c(
                        "div",
                        { staticClass: "filter-name-container editable" },
                        [
                          _vm.isCustomFilter
                            ? _c(
                                "a-tooltip",
                                {
                                  attrs: {
                                    title:
                                      _vm.filter.visibility === "public"
                                        ? _vm.$t(
                                            "chat.filterPanel.publicFilter"
                                          )
                                        : _vm.$t(
                                            "chat.filterPanel.privateFilter"
                                          ),
                                  },
                                },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons visibility-icon",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.filter.visibility === "public"
                                              ? "public"
                                              : "lock"
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "filter-name" }, [
                            _vm._v(_vm._s(_vm.displayFilterName)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "edit-name-btn",
                              attrs: {
                                title: _vm.$t(
                                  "chat.filterPanel.editFilterName"
                                ),
                              },
                              on: { click: _vm.startEditName },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("edit"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.totalContacts !== null
                        ? _c("div", { staticClass: "contact-count" }, [
                            _c("span", { staticClass: "count-text" }, [
                              _vm._v(
                                _vm._s(_vm.totalContacts || 0) +
                                  _vm._s(
                                    _vm.$t("chat.filterPanel.contactsFound")
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  : [
                      _c("div", { staticClass: "edit-name-container" }, [
                        _c("input", {
                          ref: "nameInput",
                          staticClass: "filter-name-input",
                          attrs: {
                            type: "text",
                            placeholder: _vm.$t(
                              "chat.filterPanel.enterFilterName"
                            ),
                          },
                          domProps: { value: _vm.displayFilterName },
                          on: {
                            input: _vm.onNameInput,
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.commitEditName.apply(null, arguments)
                            },
                            blur: _vm.commitEditName,
                          },
                        }),
                      ]),
                    ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.showSaveButton || _vm.isCustomFilter || true
            ? _c(
                "div",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "filter-suggestions-btn",
                      on: { click: _vm.openFilterSuggestionsModal },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("auto_awesome"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chat.filterPanel.filterSuggestions")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isSystemFilter
                    ? _c("div", { staticClass: "visibility-selector" }, [
                        _c(
                          "label",
                          {
                            staticClass: "visibility-option",
                            class: {
                              active: _vm.filterVisibility === "private",
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filterVisibility,
                                  expression: "filterVisibility",
                                },
                              ],
                              attrs: {
                                type: "radio",
                                name: "visibility",
                                value: "private",
                              },
                              domProps: {
                                checked: _vm._q(
                                  _vm.filterVisibility,
                                  "private"
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.filterVisibility = "private"
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("lock"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("chat.filterPanel.private"))
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "visibility-option",
                            class: {
                              active: _vm.filterVisibility === "public",
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filterVisibility,
                                  expression: "filterVisibility",
                                },
                              ],
                              attrs: {
                                type: "radio",
                                name: "visibility",
                                value: "public",
                              },
                              domProps: {
                                checked: _vm._q(_vm.filterVisibility, "public"),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.filterVisibility = "public"
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("public"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("chat.filterPanel.public"))),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showSaveButton
                    ? _c(
                        "SupsisButton",
                        {
                          staticClass: "save-btn",
                          attrs: { primary: "" },
                          on: { click: _vm.onSaveFilter },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("save"),
                          ]),
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.isSystemFilter
                                  ? _vm.$t("chat.filterPanel.createFilter")
                                  : _vm.$t("chat.filterPanel.update")
                              ) +
                              "\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isCustomFilter
                    ? _c("CustomPopover", {
                        attrs: {
                          showIcon: false,
                          showDropdownArrow: false,
                          popoverClass: "filter-menu-popover",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "trigger",
                              fn: function () {
                                return [
                                  _c(
                                    "button",
                                    { staticClass: "filter-menu-btn" },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("more_vert")]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "filter-menu-content" },
                                    [
                                      _vm.filter.visibility !== "public"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "filter-menu-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changeVisibility(
                                                    "public"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("public")]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "chat.filterPanel.changeToPublic"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.filter.visibility !== "private"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "filter-menu-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changeVisibility(
                                                    "private"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("lock")]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "chat.filterPanel.changeToPrivate"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "filter-menu-divider",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "filter-menu-item danger",
                                          on: { click: _vm.deleteFilter },
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("delete")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "chat.filterPanel.delete"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2217467491
                        ),
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "search-section" }, [
        _c("div", { staticClass: "search-container" }, [
          _c(
            "div",
            { staticClass: "search-field-selector" },
            [
              _c("MinimalPopoverSelect", {
                staticClass: "field-selector",
                attrs: {
                  options: _vm.fieldOptions,
                  "show-dropdown-arrow": true,
                  icon: "search",
                },
                model: {
                  value: _vm.selectedField,
                  callback: function ($$v) {
                    _vm.selectedField = $$v
                  },
                  expression: "selectedField",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "search-input-wrapper" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchQuery,
                  expression: "searchQuery",
                },
              ],
              staticClass: "search-input",
              attrs: { type: "text", placeholder: _vm.placeholderText },
              domProps: { value: _vm.searchQuery },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchContacts.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchQuery = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "search-icon-wrapper" }, [
            !_vm.searchQuery
              ? _c("i", { staticClass: "material-icons search-icon" }, [
                  _vm._v("search"),
                ])
              : _c(
                  "button",
                  {
                    staticClass: "clear-search-btn",
                    attrs: { title: _vm.$t("chat.filterPanel.clearSearch") },
                    on: { click: _vm.clearSearch },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-content-wrapper" },
        [
          _c("FiltersSection", {
            attrs: {
              filters: _vm.filters,
              state: _vm.state,
              sort: _vm.sortValue,
              total: _vm.totalContacts,
            },
            on: { "filters-changed": _vm.onFiltersChanged },
          }),
          _vm._v(" "),
          _vm.contacts.length > 0
            ? _c(
                "div",
                { staticClass: "pagination-controls" },
                [
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "pagination-btn prev-btn",
                      attrs: { disabled: !_vm.cursor.prevToken || _vm.loading },
                      on: { click: _vm.goToPrevPage },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("arrow_back"),
                      ]),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chat.filterPanel.previous")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "pagination-btn next-btn",
                      attrs: { disabled: !_vm.cursor.nextToken || _vm.loading },
                      on: { click: _vm.goToNextPage },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chat.filterPanel.next")) +
                          "\n                "
                      ),
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("arrow_forward"),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showFilterSuggestionsModal
        ? _c(
            "Modal2",
            {
              attrs: {
                design: "v3",
                "show-title": false,
                "show-footer": false,
                xlarge: true,
                "class-name": "filter-suggestions-modal",
              },
              on: { cancel: _vm.closeFilterSuggestionsModal },
            },
            [
              _c("FilterSuggestionsModal", {
                on: {
                  close: _vm.closeFilterSuggestionsModal,
                  "apply-filters": _vm.applyFiltersFromSuggestions,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("FilterNameModal", {
        attrs: {
          visible: _vm.showFilterNameModal,
          "filter-name": _vm.pendingFilterName,
          "filter-description": _vm.pendingFilterDescription,
          "suggested-name": _vm.pendingSuggestedName,
        },
        on: {
          confirm: _vm.confirmFilterName,
          cancel: _vm.cancelFilterName,
          "update-suggested-name": _vm.updateSuggestedName,
        },
      }),
      _vm._v(" "),
      _vm.showSearchModeModal
        ? _c(
            "Modal2",
            {
              attrs: {
                design: "v3",
                "show-title": true,
                "show-footer": true,
                "class-name": "search-mode-confirmation-modal",
              },
              on: { ok: _vm.confirmSearchMode, cancel: _vm.cancelSearchMode },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "search-mode-modal-title" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v(_vm._s(_vm.getSearchModeIcon())),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.getSearchModeTitle())),
                          ]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "footer",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "search-mode-modal-footer" },
                          [
                            _c(
                              "SupsisButton",
                              { on: { click: _vm.cancelSearchMode } },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "chat.filterPanel.noSearchAllFields"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.detectedSearchMode !== "mongoId"
                              ? _c(
                                  "SupsisButton",
                                  {
                                    attrs: { primary: "" },
                                    on: { click: _vm.confirmSearchMode },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "chat.filterPanel.yesSearchOnlyField",
                                            {
                                              field:
                                                _vm.getSearchModeFieldName(),
                                            }
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              : _c(
                                  "SupsisButton",
                                  {
                                    attrs: {
                                      primary: "",
                                      disabled: !_vm.mongoIdSelectedType,
                                    },
                                    on: { click: _vm.confirmSearchMode },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t("chat.filterPanel.search")
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                3373000635
              ),
            },
            [
              _vm._v(" "),
              _c("div", { staticClass: "search-mode-modal-content" }, [
                _c("p", [_vm._v(_vm._s(_vm.getSearchModeMessage()))]),
                _vm._v(" "),
                _c("div", { staticClass: "search-query-preview" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("chat.filterPanel.searchTerm"))),
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.pendingSearchQuery) + "\n            "
                  ),
                ]),
                _vm._v(" "),
                _vm.detectedSearchMode === "mongoId"
                  ? _c("div", { staticClass: "mongo-id-selection" }, [
                      _c("p", { staticClass: "selection-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("chat.filterPanel.whichFieldToSearch"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "id-type-buttons" },
                        [
                          _c(
                            "SupsisButton",
                            {
                              staticClass: "id-type-btn",
                              attrs: {
                                primary:
                                  _vm.mongoIdSelectedType === "contactId",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectMongoIdType("contactId")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("person"),
                              ]),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("chat.filterPanel.contactId")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              staticClass: "id-type-btn",
                              attrs: {
                                primary:
                                  _vm.mongoIdSelectedType === "conversationId",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectMongoIdType("conversationId")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("chat"),
                              ]),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("chat.filterPanel.conversationId")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contact-list-container" },
        [
          _c("ContactList", {
            attrs: {
              contacts: _vm.contacts,
              loading: _vm.loading,
              total: _vm.totalContacts,
              filterable: true,
              filters: _vm.tableFilters,
              "sort-field": _vm.sortField,
              "sort-direction": _vm.sortDirection,
            },
            on: {
              "filter-toggle": _vm.onFilterToggle,
              "sort-change": _vm.onSortChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }